import { MultiImagesScrollPerItem } from "../../../../commonComponents/base/multiImagesScrollPerItem"
import { LinkedItemFieldDisplay } from "../../../../commonDataObjects/linkedItemsFieldsDisplay"
import { MultiAudioRowAutoSlotItem } from "./multiAudioRowAutoSlotItem"

interface MultiAudioRowAutoSlotItemProps {
    width: number
    articles: any[]
    numberOfVisibleItems: number
    imagesDomain: string
    fieldsDisplaySettings: LinkedItemFieldDisplay
    isLTR?: boolean
    isMobileWeb?: boolean
}

export const MultiAudioRowAutoSlotList = (props: MultiAudioRowAutoSlotItemProps) => {
    const { articles, width, numberOfVisibleItems, fieldsDisplaySettings, imagesDomain, isLTR, isMobileWeb } = props
    const imageWidth = isMobileWeb ? 320 : 240;
    const imageHeight = isMobileWeb ? 320 : 240;
    let visibleItems = [];

    if (articles.length) {
        for (let i = 0; i < numberOfVisibleItems; i++) {
            if (articles[i]) {
                visibleItems.push(
                    <MultiAudioRowAutoSlotItem
                        key={i}
                        item={articles[i]}
                        imageWidth={imageWidth}
                        imageHeight={imageHeight}
                        isMobileWeb={isMobileWeb}
                        imagesDomain={imagesDomain}
                        fieldsDisplaySettings={fieldsDisplaySettings}
                    />
                )
            }
        }
    }

    return (
        <>
            {isMobileWeb ?
                <div className="slotsContent">
                    <div className="slotListWrapper">
                        {visibleItems}
                    </div>
                </div>
                :
                <MultiImagesScrollPerItem
                    isLTR={isLTR}
                    marginRight={16}
                    imageWidth={258}
                    width={(width - 116)}
                    itemLength={visibleItems.length}
                >
                    {visibleItems}
                </MultiImagesScrollPerItem>
            }
        </>
    )
}

MultiAudioRowAutoSlotList.siteScriptName = "MultiAudioRowAutoSlotList"
